import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import { useEffect } from 'react'
import { IUser } from '@/pages/Users/users.types.ts'
import usersApi from '@/pages/Users/users.api.ts'
import usePersistentState from '@/shared/hooks/usePersistentState'

/**
 * Получить всех пользователей указанной организации. Кеширует полследний результат.
 */
const useOrganizationUsers = (organizationId: IOrganization['id']) => {
  const { wait, loading } = useHttpLoader()

  const [state, setState] = usePersistentState<{ items: IUser[]; loadedForOrganization: IOrganization['id'] }>(
    { loadedForOrganization: null, items: [] },
    'organization-users',
    'inMemory'
  )

  useEffect(() => {
    if (!organizationId || organizationId === state.loadedForOrganization) return

    wait(usersApi.list({ organizationId, limit: 100 }), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: resp.body.items, loadedForOrganization: organizationId }))
      }
    })
  }, [organizationId])

  return { users: state.items, loading }
}

export default useOrganizationUsers
